export const searchResultsSelector = state => state.search.searchResults;

export const showResultsSelector = state => state.search.showResults;

export const searchGetLoadingSelector = state => state.searchGet.loading;



// WEBPACK FOOTER //
// ./src/selectors/search.js